<template>
  <div :class="{ 'bg-white': !nightMode, 'bg-dark': nightMode }" class="pt-5 p-st">
    <div class="gif-container">
      <img :src="gifPath" alt="Local GIF" class="centered-gif" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pikachu',
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      gifPath: require('@/assets/gifs/pikachu.gif')
    };
  }
};
</script>
<style scoped>
.gif-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  /* Adjust as needed */
}

.centered-gif {
  max-width: 100%;
  max-height: 100%;
}
</style>
